import { render, staticRenderFns } from "./AlertPrimarySecondary.vue?vue&type=template&id=6f7cc55e&scoped=true"
import script from "./AlertPrimarySecondary.vue?vue&type=script&lang=js"
export * from "./AlertPrimarySecondary.vue?vue&type=script&lang=js"
import style0 from "./AlertPrimarySecondary.vue?vue&type=style&index=0&id=6f7cc55e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7cc55e",
  null
  
)

export default component.exports